export default {
  archidektOrange: '#fa890d',
  quantityBlue: '#1ebb6c',
  quantityGreen: '#698bc7',
}
